<style>
.bottom-bar {
    position: fixed;
    bottom: 40px;
    width: 100%;
    background-color: white;
    box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.2);
    padding: 5px;
    z-index: 1000;
}
</style>
<template>
    <div v-if="loadingEvento">
        <v-progress-circular :size="50" color="amber" indeterminate></v-progress-circular>
    </div>
    <div v-else>
        <v-flex>
            <v-card>
                <v-card-content>
                    <InscripcionesTablaEditable :items="items" :evento="evento"
                        @refrescarDatos="() => { this.getDataFromServer() }" @paginationChange="paginationChange"
                        :loading="loading" :totalItems="totalItems" ref="inscripcionesTabla" />
                </v-card-content>
            </v-card>
            <v-layout v-if="!loading" row wrap justify-center>
                <v-flex class="bottom-bar" xs12 md6>
                    <v-btn :disabled="loading"   @click="guardarAignacionNumeros()" color="orange">Guardar Numeros</v-btn>
                    <v-btn   outline secondary @click="() => $router.go(-1)" color="secondary">Cancelar</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api/inscripcion'

import InscripcionesTablaEditable from './InscripcionesTablaEditable.vue'

export default {
    components: {
        "InscripcionesTablaEditable": InscripcionesTablaEditable
    },
    data() {
        return {
            saving: false,
            loadingEvento: true,
            loading: false,
            totalItems:0,
            items: [],
            pagination: {
                search: '',
                descending: false,
                page: 1,
                rowsPerPage: 20,
                sortBy: "id",
                totalItems: 0,
                filters: {
                    modalidad: ''
                },
            }      
        }
    },
    computed: mapState({
        
        evento: state => state.eventos.eventoActual,
        
        query: function () {
            let filters = {
                search: this.pagination.search,
                filters: {
                    estados: this.selectedStatesFilter.value
                }
            }
            if (this.selectedModalidadFilter) {
                filters.filters.modalidad = this.selectedModalidadFilter;
            }
            return filters;
        }

    }),
    created() {
        scroll(0, 0);
        let eventoId = this.$route.params.id;
        this.$store.dispatch('eventos/getEventoById', eventoId).then(() => {
            this.loadingEvento = false;
        })
    },
    watch: {
        pagination: {
            handler() {
                this.getDataFromApi()
            },
            deep: true
        }
    },
    mounted() {

    },
    methods: {
        paginationChange(pagination) {
            this.pagination = { ...this.pagination, ...pagination }
        },

        getDataFromApi() {
            this.loading = true;
            let eventoId = this.$route.params.id;

            api.getAllInscriptosEventosAsignarNumero(eventoId, this.pagination).then((res) => {
                this.items = res.data;
                this.totalItems = res.total;
                this.loading = false;
            })
        },

        guardarAignacionNumeros() {
            this.saving = true;
            let itemsTemp = this.$refs.inscripcionesTabla.getMappedItems();
            const pairs = itemsTemp.map(inscripcio => {
                return {
                    id: inscripcio.id,
                    numero: inscripcio.numero
                }
            })

            api.asignarNumerosManual(this.$route.params.id, pairs).then((res) => {
                if (res.status == 201) {
                    this.$store.commit("app/SET_MESSAGE", res.data.message);
                    this.$store.commit("app/SET_SHOW", true);
                }
                this.$router.replace('/backoffice/event/' + this.$route.params.id);

            }).finally(() => {
                this.saving = false;
            })
        },

    }

}
</script>
